import { useEffect } from "react";

/**
 * Listens for Zoom Scheduler postMessage events and redirects the parent
 * window to /booking-confirmation as soon as a booking is submitted —
 * bypassing Zoom's "Redirecting to external website" confirmation popup.
 *
 * IMPORTANT: For this to work, the parent origin (gosolar.pro) MUST be
 * whitelisted in Zoom Scheduler's embed settings. Without that Zoom blocks
 * postMessage entirely.
 */
const ZoomBookingListener = () => {
  useEffect(() => {
    const handler = (event: MessageEvent) => {
      const origin = event.origin || "";

      // Only accept messages from zoom.us domains
      let host = "";
      try {
        host = new URL(origin).hostname;
      } catch {
        return;
      }
      if (!/(^|\.)zoom\.us$/.test(host)) return;

      const data: any = event.data;

      // Log every Zoom message so we can see exactly what fires
      // (resize events are noisy — ignore them)
      if (data && data.type !== "adjustSize") {
        // eslint-disable-next-line no-console
        console.log("[Zoom postMessage]", origin, data);
      }

      if (!data || typeof data !== "object") return;

      const type = String(data.type || "").toLowerCase();
      const payloadStr = JSON.stringify(data).toLowerCase();

      const isBooking =
        type.includes("booking") ||
        type.includes("scheduled") ||
        type.includes("submitted") ||
        data.meetingBookSucceeded === true ||
        payloadStr.includes("scheduledeventid") ||
        payloadStr.includes("bookingsucceeded");

      if (isBooking) {
        // eslint-disable-next-line no-console
        console.log("[Zoom] Booking detected → redirecting to /booking-confirmation");
        window.location.assign("/booking-confirmation");
      }
    };

    window.addEventListener("message", handler);
    return () => window.removeEventListener("message", handler);
  }, []);

  return null;
};

export default ZoomBookingListener;
